import { Controller } from 'stimulus';
import moment from 'moment';

export default class extends Controller {
  static targets = ['submitButton', 'alertStatic', 'alertDynamic', 'alertDynamicText', 'timer', 'timerText'];

  messageTimeout = 8; //sec
  messageTimer = null;

  initialize() {
    this.initialCheckIfLocked();
  }

  initialCheckIfLocked() {
    try {
      const retryAt = this.submitButtonTarget.dataset.retryAt;

      if (retryAt && moment(new Date(retryAt)).isAfter(moment())) {
        this.submitButtonTarget.setAttribute('disabled', 'disabled');

        this.startTimer(retryAt);


        if (this.hasAlertStaticTarget && this.alertStaticTarget.classList.contains('alert-success')) {
          this.alertStaticTarget.classList.remove('show');
          this.alertStaticTarget.classList.add('d-none');
        }
      }
    } catch (e) {
      console.error(e);
    }
  }

  startTimer(initDateTime) {
    const reloadAt = initDateTime ? moment(initDateTime) : moment();

    const timer = setInterval(() => {
      const now = moment();
      const diff = moment.duration(reloadAt.diff(now));
      const minutes = diff.minutes();
      const seconds = diff.seconds();

      if ((minutes < 1) && (seconds < 1)) {
        clearInterval(timer);
        location.reload();
      } else {
        this.timerTextTarget.innerText = `${minutes < 10 ? `0${minutes}` : minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
        this.timerTarget.classList.remove('d-none');
        this.timerTarget.classList.add('show');
      }
    }, 1000);
  }
  showDynamicSuccess(message) {
    this.alertDynamicTextTarget.innerText = message;
    this.alertDynamicTarget.classList.add('show');

    if (this.messageTimer) {
      clearTimeout(this.messageTimer);
    }

    this.messageTimer = setTimeout(() => {
      this.alertDynamicTarget.classList.remove('show');
    }, this.messageTimeout * 1000);
  }

  handleSuccess(data) {
    // hide static ERROR alert if it's visible
    if (this.alertStaticTarget.classList.contains('alert-danger')) {
      this.alertStaticTarget.classList.remove('show');
      this.alertStaticTarget.classList.add('d-none');
    }

    // show dynamic SUCCESS alert
    this.showDynamicSuccess(data.message || 'Success!');
  }

  handleError(error) {
    const response = (error && error.responseJSON) || {message: 'Something went wrong. Please try again'};

    // hide dynamic SUCCESS alert if it's visible
    this.alertDynamicTarget.classList.remove('show');

    // show static ERROR alert
    this.alertStaticTarget.classList.remove('alert-success', 'd-none');
    this.alertStaticTarget.classList.add('alert-danger', 'show');
    this.alertStaticTarget.innerText = response.message;

    // show timer if it's available
    if (response.retry_at) {
      this.startTimer(response.retry_at);
    }
  }

  submitForm(e) {
    e.preventDefault();
    e.stopPropagation();

    const authTokenEl = document.querySelector('meta[name="csrf-token"]');
    const authToken = authTokenEl ? authTokenEl.getAttribute('content') : '';
    const { target } = e;

    target.setAttribute('disabled', 'disabled');

    $.ajax({
      url: target.dataset.url,
      type: 'POST',
      headers: {
        'X-CSRF-Token': authToken,
      }
    }).then((data) => {
      target.removeAttribute('disabled');
      this.handleSuccess(data);
    }, (error) => {
      this.handleError(error);
    });
  }
}
